import { CssBaseline, ThemeProvider } from '@mui/material';
import { Amplify } from 'aws-amplify';
import ReactDOM from 'react-dom/client';
import { QueryCache, QueryClient, QueryClientProvider } from 'react-query';
import { HashRouter } from 'react-router-dom';
import { FlagProvider } from '@unleash/proxy-client-react';
import { IsWindowVisibleProvider } from './App/LiveContext/Hooks/useIsWindowVisible';
import AuthenticatedApp from './AuthenticatedApp';
import awsConfig from './aws-exports';
import './datadog';
import './awsRum';
import './i18n';
import './index.css';
import reportWebVitals from './reportWebVitals';
import theme from './theme';
import config from './config';
import AppInstallContextProvider from './App/Contexts/AppInstallContext/AppInstallContextProvider';
import OfflineScreenWrapper from './Components/OfflineScreenWrapper';
import SwContextProvider from './App/Contexts/SwContext/SwContextProvider';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

Amplify.configure(awsConfig);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },

  queryCache: new QueryCache({
    onError: (error, query) => {
      console.error(`An error occurred trying to fetch for key "${JSON.stringify(query.queryKey)}"`, error);
    },
  }),
});

root.render(
  <AppInstallContextProvider>
    <SwContextProvider>
      <ThemeProvider theme={theme}>
        <OfflineScreenWrapper>
          <FlagProvider config={config.Unleash}>
            <QueryClientProvider client={queryClient}>
              <IsWindowVisibleProvider>
                <HashRouter>
                  <CssBaseline />
                  <AuthenticatedApp />
                </HashRouter>
              </IsWindowVisibleProvider>
            </QueryClientProvider>
          </FlagProvider>
        </OfflineScreenWrapper>
      </ThemeProvider>
    </SwContextProvider>
  </AppInstallContextProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
